module.exports = __webpack_public_path__ + "img/bluesky3100_13.ed2e9c70.jpg";